import React, { useState, useEffect } from 'react';
import {
  LayoutDashboard,
  User,
  MapPin,
  UserCheck,
  GraduationCap,
  ChevronUp,
  ChevronDown,
  UserX,
  Users,
  Briefcase,
  FileText,
  Menu,
  ClipboardCheck
} from 'lucide-react';
import {
  FaBars,
  FaTimes
} from 'react-icons/fa';
import { Outlet, useNavigate, useLocation, Link } from 'react-router-dom';
import TopNavbar from '../../top-navbar/TopNav';
import '../../top-navbar/topnavBar.css';
import PaymentsIcon from "@mui/icons-material/Payments";

const Navbar = () => {
  const [showEmployeeSubMenu, setShowEmployeeSubMenu] = useState(false);
  const [showClientSubMenu, setShowClientSubMenu] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const getTitleForPage = () => {
    const path = location.pathname;
    const state = location.state;

    if (state?.heading) return state.heading;
    // if (path.includes('dashboard')) return 'Dashboard';
    if (path.includes('view-profile')) return 'View Profile';
    if (path.includes('pending')) return 'Pending Client List';
    if (path.includes('rejected')) return 'Rejected Client List';
    if (path.includes('clients')) return 'Approved Client List';
    if (path.includes('reports')) return 'Candidate Report';
    if (path.includes('add-employee')) return 'Add New Agent';
    if (path.includes('inactive-employee')) return 'Inactive Agent';
    if (path.includes('active-employee')) return 'Active Agent';
    if (path.includes('employee') && path.includes('candidates')) return 'Assigned Candidates';
    if (path.includes('/admin/candidates/')) return 'Candidates By Status';
    if (path.includes('candidates')) return 'Client Candidates';
    if (path.includes('candidate-details')) return 'Candidate Details';
    if (path.includes('service-down')) return 'Service Down';
    // return 'Dashboard';
  };

  const sidebarWidth = '12rem';

  return (
    <div className="admin-dashboard-container">
      <TopNavbar />

      <button
        className="admin-hamburger-btn"
        onClick={() => setIsSidebarOpen(!isSidebarOpen)}
      >
        {isSidebarOpen ? <FaTimes /> : <FaBars />}
      </button>

      <aside
        className={`admin-dashboard-sidebar ${isSidebarOpen ? 'open' : ''}`}
        style={{ width: sidebarWidth }}
      >
        <button
          className="admin-sidebar-close-btn"
          onClick={() => setIsSidebarOpen(false)}
        >
          <FaTimes />
        </button>

        <nav>
          <ul className="admin-sidebar-menu">
            <li
              className={`admin-sidebar-menu-item ${location.pathname === '/admin' ? 'active' : ''}`}
            >
              <Link
                to="/admin"
                className="admin-sidebar-link"
              >
              <LayoutDashboard className="admin-sidebar-icon" />
              <span>Dashboard</span>
              </Link>
            </li>
            <div className="admin-sidebar-divider"></div>

            <li
              className={`admin-sidebar-menu-item ${
                location.pathname === '/admin/view-profile' ? 'active' : ''}`}
            >
              <Link
                to="/admin/view-profile"
                className="admin-sidebar-link"
              >
              <User className="admin-sidebar-icon" />
              <span>View Profile</span>
              </Link>
            </li>
            <div className="admin-sidebar-divider"></div>

            <li
  onClick={() => setShowClientSubMenu(!showClientSubMenu)}
  className="admin-sidebar-menu-item"
>
  <div className="items-center">
    <User className="admin-sidebar-icon" />
    <span>Clients</span>
  </div>
  {showClientSubMenu ? <ChevronUp /> : <ChevronDown />}
</li>

{showClientSubMenu && (
  <ul className="admin-sidebar-submenu">

    {/* Pending */}
    <li
      className={`admin-sidebar-submenu-item ${
        location.pathname === '/admin/clients/pending' ? 'active' : ''
      }`}
    >
      <Link 
        to="/admin/clients/pending"
        className="admin-sidebar-link"
      >
      <UserCheck className="admin-sidebar-icon sub-icon" />
      <span>Pending Approvals</span>
      </Link>
    </li>

    {/* Approved */}
    <li
      className={`admin-sidebar-submenu-item ${
        location.pathname === '/admin/clients/approved' ||
        location.pathname === '/admin/clients'
          ? 'active'
          : ''
      }`}
    >
      <Link
        to="/admin/clients"
        className="admin-sidebar-link"
      >
      <Users className="admin-sidebar-icon sub-icon" />
      <span>Approved Clients</span>
      </Link>
    </li>

    {/* Rejected */}
    <li
      className={`admin-sidebar-submenu-item ${
        location.pathname === '/admin/clients/rejected' ? 'active' : ''
      }`}
    >
      <Link
        to="/admin/clients/rejected"
        className="admin-sidebar-link"
      >
      <UserX className="admin-sidebar-icon sub-icon" />
      <span>Rejected Clients</span>
      </Link>
    </li>

  </ul>
)}

<div className="admin-sidebar-divider"></div>


            <li
              className={`admin-sidebar-menu-item ${location.pathname === '/admin/add-employee' ? 'active' : ''}`}
            >
              <Link
                to="/admin/add-employee"
                className="admin-sidebar-link"
              >
              <MapPin className="admin-sidebar-icon" />
              <span>Add Agent</span>
              </Link>
            </li>
            <div className="admin-sidebar-divider"></div>

            <li
              onClick={() => setShowEmployeeSubMenu(!showEmployeeSubMenu)}
              className="admin-sidebar-menu-item"
            >
              <div className="items-center">
                <GraduationCap className="admin-sidebar-icon" />
                <span>Agent List</span>
              </div>
              {showEmployeeSubMenu ? <ChevronUp /> : <ChevronDown />}
            </li>
            <div className="admin-sidebar-divider"></div>
            {showEmployeeSubMenu && (
              <ul className="admin-sidebar-submenu">
                <li
                  className={`admin-sidebar-submenu-item ${location.pathname === '/admin/active-employee' ? 'active' : ''
                    }`}
                >
                  <Link
                   to="/admin/active-employee"
                   className="admin-sidebar-link"
                  >
                  <Briefcase className="admin-sidebar-icon sub-icon" />
                  <span>Active Agents</span>
                  </Link>
                </li>
                <li
                  className={`admin-sidebar-submenu-item ${location.pathname === '/admin/inactive-employee' ? 'active' : ''
                    }`}
                >
                  <Link
                   to="/admin/active-employee"
                   className="admin-sidebar-link"
                  >
                  <FileText className="admin-sidebar-icon sub-icon" />
                  <span>Inactive Agents</span>
                  </Link>
                </li>
              </ul>
            )}
            <li className={`admin-sidebar-menu-item ${location.pathname === '/admin/bgv-cases' ? 'active' : ''}`}>
                  <Link to="/admin/bgv-cases" className="admin-sidebar-link">
                    <ClipboardCheck className="admin-sidebar-icon" />
                    <span>All BGV Cases</span>
                  </Link>
                </li>

          <div className="admin-sidebar-divider"></div>
             <li className={`admin-sidebar-menu-item ${location.pathname === '/admin/client-payment-details' ? 'active' : ''}`}>
                  <Link to="/admin/client-payment-details" className="admin-sidebar-link">
                  <PaymentsIcon className="admin-sidebar-icon" />
                    <span>Client Payments</span>
                  </Link>
                </li>
          
          </ul>
        </nav>
      </aside>

      {isSidebarOpen && (
        <div
          className="sidebar-overlay"
          onClick={() => setIsSidebarOpen(false)}
        ></div>
      )}

      <main className="admin-dashboard-main">
        <div className="admin-dashboard-header-row">
          <div className="admin-dashboard-title-bar">
            <h2 className="admin-page-title">{getTitleForPage()}</h2>
          </div>
        </div>

        <div className="admin-dashboard-page-content">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default Navbar;
